import React from "react";
import "./skeletonLoader.scss";

interface SkeletonProductCardProps {
    count?: number;
    columnClass?: string;
}

export const SkeletonProductCard: React.FC<SkeletonProductCardProps> = ({ 
    count = 1, 
    columnClass = "col-md-3 mb-4" 
}) => {
    return (
        <>
            {Array.from({ length: count }, (_, index) => (
                <div key={index} className={columnClass}>
                    <div className="skeleton-product-card">
                        <div className="skeleton-product-image-container">
                            <div className="skeleton-product-image"></div>
                        </div>
                        <div className="skeleton-product-details">
                            <div className="skeleton-product-info">
                                <div className="skeleton-product-name"></div>
                                <div className="skeleton-product-company"></div>
                            </div>
                            <div className="skeleton-product-actions">
                                <div className="skeleton-button"></div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export const SkeletonSection: React.FC<{ title: string; count?: number }> = ({ title, count = 4 }) => {
    return (
        <div className="skeleton-section">
            <div className="skeleton-section-header">
                <div className="skeleton-section-title"></div>
            </div>
            <div className="row">
                <SkeletonProductCard count={count} />
            </div>
        </div>
    );
};
